const states = [
  "primary",
  "secondary",
  "warning",
  "error",
  "info",
  "dark",
  "success",
];

export default states;
